import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Connection } from 'honeygrid-types/validators-and-types/ConnectionTypes'
import { toast } from 'sonner'

import { connectionQueryKey } from './useConnection'
import { connectionsQueryKey } from './useConnections'

interface DeleteConnectionParams {
	workspaceId?: string
	connectionId: Connection['uuid']
}

export const useDeleteConnection = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()

	return useMutation({
		mutationFn: async ({ workspaceId = '', connectionId }: DeleteConnectionParams) => {
			if (!workspaceId) {
				toast.error('Workspace ID is required')
				throw new Error('Workspace ID is required')
			}
			return authFetch(`workspaces/${workspaceId}/connections/${connectionId}`, {
				method: 'DELETE',
			})
		},
		onSuccess: (_, { workspaceId, connectionId }) => {
			if (!workspaceId) {
				toast.error('Workspace ID is required')
				throw new Error('Workspace ID is required')
			}
			queryClient.invalidateQueries({
				queryKey: connectionsQueryKey(workspaceId),
			})
			queryClient.invalidateQueries({
				queryKey: connectionQueryKey(workspaceId, connectionId),
			})
		},
	})
}
